(function () {
  'use strict';

  function formatMoney(cents) {
    var formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD' });
    return formatter.format((cents || 0) / 100);
  }

  // The picker renders as a sibling of the product form, not inside it, so fall back
  // to the add-to-cart form in the same product info column.
  function findForm(picker) {
    var form = picker.closest('form[action*="/cart/add"]');
    if (form) return form;
    var scope = picker.closest('.product__info-container') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  function updateBuyButtonLabel(picker, option) {
    var form = findForm(picker);
    if (!form) return;
    var button = form.querySelector('[name="add"]');
    if (!button) return;
    var labelSpan = button.querySelector('span:not(.loading__spinner)') || button;
    var ctaText = picker.dataset.ctaPrefix || 'Add to Cart';
    var price = parseInt(option.dataset.priceCents, 10);
    if (isNaN(price)) {
      labelSpan.textContent = ctaText;
    } else {
      labelSpan.textContent = ctaText + ' · ' + formatMoney(price);
    }
  }

  function updateFormVariantId(picker, option) {
    var form = findForm(picker);
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (input) input.value = option.dataset.variantId;
  }

  function broadcast(option) {
    document.dispatchEvent(new CustomEvent('pdp:option-changed', {
      detail: {
        variantId: option.dataset.variantId,
        productHandle: option.dataset.productHandle,
        productTitle: option.dataset.productTitle,
        priceCents: parseInt(option.dataset.priceCents, 10),
        thumbnail: option.dataset.thumbnail
      }
    }));
  }

  function selectOption(picker, option) {
    picker.querySelectorAll('.kit-picker__option').forEach(function (el) {
      el.classList.remove('is-selected');
      var input = el.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
    option.classList.add('is-selected');
    var input = option.querySelector('input[type="radio"]');
    if (input) input.checked = true;

    updateFormVariantId(picker, option);
    updateBuyButtonLabel(picker, option);
    broadcast(option);
  }

  function init(picker) {
    if (picker.dataset.kitPickerInitialized === 'true') return;
    picker.dataset.kitPickerInitialized = 'true';

    var options = picker.querySelectorAll('.kit-picker__option');
    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        selectOption(picker, option);
      });
      var radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) selectOption(picker, option);
        });
      }
    });

    var preselected = picker.querySelector('.kit-picker__option.is-selected') || options[0];
    if (preselected) {
      updateFormVariantId(picker, preselected);
      updateBuyButtonLabel(picker, preselected);
      broadcast(preselected);
    }
  }

  function initAll() {
    document.querySelectorAll('.kit-picker').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var pickers = e.target.querySelectorAll ? e.target.querySelectorAll('.kit-picker') : [];
    pickers.forEach(init);
  });
})();
